import { PPagination, type PaginationUpdateEvent } from '@porsche-design-system/components-react';
import { type PaginationProps } from 'antd';
import React from 'react';

const Pagination = ({ current, total, pageSize, onChange }: PaginationProps) => {
    const onPageChange = (event: CustomEvent<PaginationUpdateEvent>) => {
        onChange?.(event.detail.page, pageSize);
    };

    return <PPagination activePage={current} itemsPerPage={pageSize} onUpdate={onPageChange} totalItemsCount={total} />;
};

export default Pagination;
